// src/components/canine-teeth-ai/SavedSessionsGallery.js

import React, { useEffect, useState } from 'react';
import { getSessionsByEmailAndTool, deleteSession } from '../../indexedDB'; // Importa la nuova funzione
import PropTypes from 'prop-types';
import '../tools.css';

function SavedSessionsGallery({ onSelectSession, sessionsCount, userEmail }) {
  const [savedSessions, setSavedSessions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSessions = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const tool = 'canine-teeth-ai'; // Specifica il tool desiderato
        const sessions = await getSessionsByEmailAndTool(userEmail, tool); // Usa la nuova funzione
        console.log('Sessioni recuperate:', sessions);
        setSavedSessions(sessions);
      } catch (error) {
        console.error('Errore nel recuperare le sessioni:', error);
        setError('Errore nel recuperare le sessioni. Riprova più tardi.');
      } finally {
        setIsLoading(false);
      }
    };

    if (userEmail) { // Assicurati di avere l'email dell'utente prima di chiamare fetchSessions
      fetchSessions();
    } else {
      setSavedSessions([]);
      setIsLoading(false);
    }
  }, [sessionsCount, userEmail]);

  const handleDeleteSession = async (sessionName) => {
    try {
      await deleteSession(sessionName, userEmail); // Passa anche userEmail
      // Aggiorna lo stato delle sessioni dopo la cancellazione
      setSavedSessions((prevSessions) =>
        prevSessions.filter((session) => session.subImage.name !== sessionName)
      );
    } catch (error) {
      console.error('Errore nella cancellazione della sessione:', error);
      alert('Si è verificato un errore durante la cancellazione della sessione. Riprova.');
    }
  };

  if (isLoading) {
    return <div className="loading-container">Caricamento sessioni...</div>;
  }

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  if (savedSessions.length === 0) {
    return <div className="no-sessions">Nessuna sessione salvata per il tool specificato.</div>;
  }

  return (
    <div className="gallery-container">
      <h3 className="gallery-title">Saved sessions </h3>
      <div className="gallery-grid">
        {savedSessions.map((session) => {
          // Verifica che la sessione sia valida
          if (
            !session ||
            !session.subImage ||
            !session.subImage.dataURL ||
            typeof session.subImage.dataURL !== 'string' ||
            !session.subImage.dataURL.startsWith('data:image')
          ) {
            console.error('Sessione non valida o immagine non disponibile:', session);
            return (
              <div key={session.id || session.subImage.name} className="gallery-card invalid-session">
                <p>Dati sessione non validi o immagine non disponibile.</p>
                <button
                  onClick={() => handleDeleteSession(session.subImage.name)}
                  className="delete-button"
                >
                  Elimina
                </button>
              </div>
            );
          }

          return (
            <div key={session.id} className="gallery-card">
              <img
                src={session.subImage.dataURL}
                alt={`Sessione ${session.id}`}
                className="gallery-image"
                onClick={() => onSelectSession({
                  ...session,
                  realAge: session.realAge || '' // Aggiungo il realAge alla sessione
                })}
              />
              <p className="gallery-image-name">{session.subImage.name}</p>
              <button
                onClick={() => handleDeleteSession(session.subImage.name)}
                className="delete-button"
              >
                Elimina
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Definizione dei tipi delle props per una migliore manutenibilità e debugging
SavedSessionsGallery.propTypes = {
  onSelectSession: PropTypes.func.isRequired,
  sessionsCount: PropTypes.number.isRequired,
  userEmail: PropTypes.string.isRequired,
};

export default SavedSessionsGallery;
